import React from 'react'
import Navbar from './Navbar'
import BarresearchP from '../../COMPONENTS/BarreSearchP/BarreSearchP'
import accueil from '../../../ASSETS/tourisme/Image/accueilCulture.png'
import { useTranslation } from 'react-i18next'

function BackImage() {
    const {t} = useTranslation() as {t:(key:string)=>string}

    let code = localStorage.getItem('code')
    let iso_code = localStorage.getItem('is_code')

  
  return (
    <div>
         {/* navbar */}
            <Navbar />
            {/* back image */}
            <div className=' bg-cover z-0 flex-col bg-center bg-no-repeat h-96  w-screen relative flex justify-center items-center' style={{ backgroundImage: `url(${accueil})`}}>
                <div className='navbar_animation flex items-center justify-center sm:pt-40 md:pt-0'>

                    <div className=' text-white md:text-7xl sm:text-3xl font-semibold uppercase '>
                        {t("Culture & decouverte")}
                    </div>
                </div>

            </div>

            {/* barre de recherche principale */}
            {/* <div className=' absolute inset-x-0 md:-bottom-20 xs:-bottom-40 s:-bottom-64 flex justify-center  '>
                <BarresearchP cde={code ? code : iso_code} />
            </div> */}

            {/* title */}
            <div className='relative md:mt-10 s:mt-2  px-10 pb-20'>

                <div className=' space-y-4'>
                    <p className='md:text-2xl s:text-lg  font-medium text-orange-400'>{t("Culture & Decouverte")}</p>
                    <p className='md:text-3xl s:text-xl font-semibold text-zinc-800'>{t("Vivez Votre Vie À Travers Les Voyages")}</p>
                    <p className='md:text-lg s:text-sm'>{t("Découvrez les différents sites touristiques à visités et diverses activités sur la plateforme")}.</p>
                </div>
            </div>
    </div>
  )
}

export default BackImage